module.exports = __webpack_public_path__ + "static/trust_logo@2x-029db7a65e172a21dafda08cab25dbf9.png";